/**
 * Retrieve visitor attribution cookie from Qustodio API.
 */
import ajaxRequest from '../helpers/ajaxRequest';

const visitorAttribution = () => {
  const attributionParam = 'utm_source';
  const ajaxEndpoint = '/api/visitor-attribution';

  const urlHasAttributionParam = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(attributionParam);
  };

  const requestAttributionCookie = () => {
    const requestData = { url: window.location.href };
    ajaxRequest(ajaxEndpoint).post(requestData);
  };

  const init = () => {
    if (urlHasAttributionParam()) {
      requestAttributionCookie();
    }
  };

  return {
    init,
  };
};

export default visitorAttribution();
